import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${(props) => props.theme.common.mainHeadingColor};
    overflow: hidden;
    background: ${(props) => props.theme.layout.bg};
  }

  /* Modern mobile feel */
  * {
    -webkit-tap-highlight-color: transparent;
  }

  html,
  body {
    text-rendering: optimizeLegibility;
  }

  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-family: inherit;
    font-weight: 400;
  }

  a,
  a:active,
  a:hover {
    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
  }

  button,
  input {
    border: none;
    background-color: transparent;
  }

  input::placeholder {
    opacity: 0.75;
  }

  ul {
    list-style: none;
  }

  ::-webkit-scrollbar {
    width: 8px !important;
    height: 8px !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(17, 24, 39, 0.18);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(17, 24, 39, 0.06);
  }

  /* Firefox */
  html {
    scrollbar-color: rgba(17, 24, 39, 0.22) rgba(17, 24, 39, 0.06);
    scrollbar-width: thin;
  }

  @media screen and (max-width: 768px) {
    ::-webkit-scrollbar {
      width: 6px !important;
      height: 6px !important;
    }
  }
`;

export default GlobalStyle;
